import { Text, View } from '@adobe/react-spectrum';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

// Monorepo shared components
import { WithSkeleton } from '@exchange-frontends/components';
import { useRootHref } from '@exchange-frontends/custom-hooks';

import { ConfigContext } from '../../App';

const SidebarInstallationInstructions = ({ publisherLoading, id, name, versionId }) => {
  const { ROUTES } = useContext(ConfigContext) ?? {};
  const installationInstructionsURL = useRootHref(
    `${ROUTES.DETAILS}/cc/installation-instructions/${versionId}/${encodeURIComponent(name)}`
  );

  return (
    <View
      backgroundColor="static-white"
      borderRadius="regular"
      padding="size-200"
      borderWidth="thin"
      borderColor="gray-200"
      marginBottom="size-400"
    >
      <WithSkeleton shouldRender={!publisherLoading}>
        <Text>{`Unable to install from CCD? `}</Text>
        <Link to={installationInstructionsURL} data-launchid={`Help and Support : Installation help`}>
          Installation Help
        </Link>
      </WithSkeleton>
    </View>
  );
};

export default SidebarInstallationInstructions;
